import { ICreateRouteInputDto } from './create-route-dto.interface';

export type IUpdateRouteInputDto = Partial<ICreateRouteInputDto>;
